// import {Mutex} from "async-mutex";
import { RootState } from "shared/config/store/store";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { QueryReturnValue } from "@reduxjs/toolkit/dist/query/baseQueryTypes";
import { ENABLED_NETWORK_LOGGER } from "shared/const/env";
import { setUser } from "shared/config/store/reducers/userSlice";
import { ROUTES } from "shared/const/routes";
import { PURGE } from "redux-persist";
import { store } from "shared/config/store/store";

function isSessionTerminatedError(error: any): boolean {
    const errors = error?.data?.errors;
    return Array.isArray(errors) && errors.some((e: any) => e.id === 'errors.session');
}

const customBaseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
        const state = getState() as RootState, token = state.user.token;
        if (token) headers.set('Authorization', token);
        return headers;
    },
});
const baseQueryWithRefresh = async (args: any, api: any, extraOptions: any) => {
    const logRequest = (status: string, res?: QueryReturnValue) => {
        if (ENABLED_NETWORK_LOGGER) {
            console.debug(`[Network] ${status}: ${args.method} ${args.url}`);
            if (args.body) {
                console.debug(`body: `, args.body);
            }
            if (args.params) {
                console.debug(`query: `, args.params);
            }
            if (status === 'Success' && res?.data) {
                console.debug(`response: `, res.data);
            } else if (status === 'Error' && res?.error) {
                console.debug(`error: `, res.error);
            }
        }
    };

    const executeQuery = async (): Promise<any> => {
        logRequest('Pending');
        const result = await customBaseQuery(args, api, extraOptions);

        const authHeader = result?.meta?.response?.headers?.get('Authorization');
        if (authHeader) api.dispatch(setUser({ token: authHeader }));

        if (result.error) {
            logRequest('Error', result);
        } else {
            logRequest('Success', result);
        }

        return result;
        // if (result.error && result.error?.status === 401) {
        //     if (!mutex.isLocked()) {
        //         const release = await mutex.acquire();
        //         try {
        //             await api.dispatch(refreshToken());
        //         } finally {
        //             release();
        //         }
        //         return customBaseQuery(args, api, extraOptions);
        //     } else {
        //         await mutex.waitForUnlock();
        //         return executeQuery();
        //     }
        // } else return result;
    };

    const result = await executeQuery();
    if (result.error && 'status' in result.error) {
        switch (result.error.status) {
            // case 401:
            //     await resetAllStates();
            //     enqueueSnackbar('Сессия истекла', {
            //         autoHideDuration: 3000,
            //         preventDuplicate: true,
            //     });
            //     break;
            // case 403:
            //     enqueueSnackbar('Доступ запрещен', {
            //         autoHideDuration: 3000,
            //         preventDuplicate: true,
            //     });
            //     break;
            // case 'FETCH_ERROR':
            //     enqueueSnackbar('Ошибка доступа', {
            //         autoHideDuration: 3000,
            //         preventDuplicate: true,
            //     });
            //     break;
            default:
                break;
        }
    }

    if (result.error) {
        if (isSessionTerminatedError(result.error)) {
                try {
                    localStorage.removeItem('userData');
                    store.dispatch({ type: PURGE, key: 'root', result: () => null });
                    store.dispatch(api.util.resetApiState());
                    window.location.href = ROUTES.LOGIN.path;
                } catch (error) {
                    console.error('Failed to handle session termination:', error);
                }
            return; 
        }
    }

    return result;
};

export const api = createApi({
    reducerPath: 'index',
    baseQuery: baseQueryWithRefresh,
    tagTypes: ['user', 'cryptoUser', 'accounts', 'transactions', 'user-avatar', 'notifications'],
    endpoints: (build) => ({
    }),
});

